/**
 * Testimonial preview
 */

var AwesomeSettings = function (){
    'use strict';

    var $ = jQuery; // enable jQuery
    var self = this;

    // two way data bindings for edit group form
    self.bind_form = function(){
        var dfd = $.Deferred();

        dfd.resolve();
        return dfd;
    };


    // destroy preview
    self.destroy = function(){

    };

    // init preview
    self.init = function(){
        self.bind_form();
        var form = new AwesomeForm();
        form.init(settings_model);

        window.settings_form_view = new SettingsForm({
            model: window.settings_model
        });
        settings_form_view.setElement($('#settings-wrap', aet_panel));
        settings_form_view.render();

        $('select', aet_panel).fsdropdown();
    };
};